let pms_no_of_units = [];

for (let x = 1; x < 18; x++) {
  pms_no_of_units.push({
    value: x,
    name: "" + x,
  });
}

export default pms_no_of_units;



// WEBPACK FOOTER //
// ./src/constants/pms_no_of_units.js